import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core'
import { uniq } from 'lodash'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { takeUntil } from 'rxjs/operators'
import { Subject } from 'rxjs'

// SDK
import {
  PackingList,
  PackingListsService,
  PickingList,
  PickingListsService,
  StatusHistory,
  User,
  UsersService,
} from '@evologi/shared/data-access-api'
import { TranslationService } from '@evologi/shared/util-translation'
import { DatePipe } from '@angular/common'

@Component({
  selector: 'op-modal-history',
  templateUrl: './modal-history.component.html',
  styleUrls: ['./modal-history.component.scss'],
  providers: [DatePipe],
})
export class ModalHistoryComponent implements OnInit, OnDestroy {
  @Output() readonly action = new EventEmitter()
  @Input() public btnClass = ''

  // Models
  public title?: string
  public documentType?: string
  public documentRef?: string | number
  public history: StatusHistory[] = []
  public status: any[] = []
  public users: User[] = []
  public pickingList?: PickingList
  public packingList?: PackingList
  public pickingListId?: string
  public packingListId?: string

  // Observable
  private destroy$: Subject<boolean> = new Subject<boolean>()

  constructor(
    private usersService: UsersService,
    private pickingListsService: PickingListsService,
    private packingListsService: PackingListsService,
    private translationService: TranslationService,
    private datePipe: DatePipe,
    public modal: BsModalRef,
  ) {}

  // Lifecycle methods

  ngOnInit() {
    const userIds = uniq(this.history.map((history) => history.userId!))
    this.usersService
      .list$({ _id: userIds })
      .pipe(takeUntil(this.destroy$))
      .subscribe((users) => (this.users = users))

    if (this.pickingListId) {
      this.pickingListsService
        .search$({ _id: this.pickingListId })
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (picking) =>
            (this.pickingList =
              picking?.data.length > 0 ? picking?.data[0] : undefined),
        )
    }

    if (this.packingListId) {
      this.packingListsService
        .search$({ _id: this.packingListId })
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (packing) =>
            (this.packingList =
              packing?.data.length > 0 ? packing?.data[0] : undefined),
        )
    }
  }

  lastStatusHistory(): string {
    const statusHistory: StatusHistory<string>[] | undefined =
      this.packingList?.statusHistory
    if (!statusHistory?.length) {
      return (
        this.translationService.translate('Created at') +
        ': ' +
        this.datePipe.transform(this.packingList?.createdAt, 'medium')
      )
    }
    const lastStatusHistory = statusHistory[statusHistory.length - 1]
    return (
      this.translationService.translate(lastStatusHistory.status) +
      ': ' +
      this.datePipe.transform(lastStatusHistory.date, 'medium')
    )
  }

  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.unsubscribe()
  }
}
